import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

const STORAGE_KEY = 'from_mobile_app';

const useFromMobileApp = (): boolean => {
	const [fromApp, setFromApp] = useState(false);
	const router = useRouter();

	useEffect(() => {
		if (router.query.from_mobile_app === 'true') {
			sessionStorage.setItem(STORAGE_KEY, 'true');
			setFromApp(true);
		} else if (typeof window !== 'undefined') {
			const stored = sessionStorage.getItem(STORAGE_KEY);
			setFromApp(stored === 'true');
		}
	}, [router.query]);

	return fromApp;
};

export default useFromMobileApp;
